import { PageHeader } from "@/components/PageHeader/PageHeader";
import { Col, Flex, Row } from "antd";

import useTrackOnLoad from "@/hooks/useTrackPageview";
import ManageScope from "@/pages/settings/ManageScope";
import ManageMethod from "./ManageMethod";

function Settings() {
  useTrackOnLoad("Manage settings viewed");

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader title="Settings" />
      <Row gutter={[10, 24]}>
        <Col span={24}>
          <ManageScope />
        </Col>
        <Col span={24}>
          <ManageMethod />
        </Col>
      </Row>
    </Flex>
  );
}

export default Settings;
